<ng-container *hasPermission="['SAFESTREET_ADMIN']">
    <div class="container-fluid">
        <div class="page-title">
            <h2>Parametri app palmare default</h2>
        </div>
        <div class="section-container" *ngIf="defaultAppSettingsForm">
            <form [formGroup]="defaultAppSettingsForm" (ngSubmit)="onSave()">
                <div class="row">
                    <div class="col-12 mb-4" *ngFor="let group of groupedDefaultAppSettings">
                        <div class="card h-100">
                            <div class="card-header bg-secondary text-white">{{computeComponentLabel(group.component)}}</div>
                            <div class="card-body">
                                <div class="row mb-3 align-items-center" *ngFor="let defaultAppSetting of group.settings">
                                    <div class="col-6">{{defaultAppSetting.description}}</div>
                                    <div class="col-6">
                                        @if (defaultAppSetting.type === 'integer') {
                                        <input type="number" [id]="defaultAppSetting.keyId" [name]="defaultAppSetting.keyId!"
                                            [formControlName]="defaultAppSetting.keyId!" class="form-control">
                                        }
                                        @else if(defaultAppSetting.type === 'string'){
                                        <input type="text" [id]="defaultAppSetting.keyId" [name]="defaultAppSetting.keyId!"
                                            [formControlName]="defaultAppSetting.keyId!" class="form-control">
                                        }
                                        @else if(defaultAppSetting.type === 'boolean'){
                                        <div class="form-check">
                                            <input class="form-check-input" type="checkbox" [id]="defaultAppSetting.keyId"
                                                [name]="defaultAppSetting.keyId!" [formControlName]="defaultAppSetting.keyId!">
                                        </div>
                                        } @else if(defaultAppSetting.type === 'double'){
                                        <input type="text" [id]="defaultAppSetting.keyId" [name]="defaultAppSetting.keyId!"
                                            [formControlName]="defaultAppSetting.keyId!" class="form-control">

                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="d-flex justify-content-end">
                    <button type="submit" class="btn btn-primary">Salva</button>
                </div>
            </form>
        </div>
    </div>
</ng-container>
